// extracted by mini-css-extract-plugin
export default {"nav":"RootAdmin_nav__2cQSk","viewLayout":"RootAdmin_viewLayout__MwKMJ","navbarList":"RootAdmin_navbarList__nORIi"};